<template>
  <div class="maintenance-records" :style="containerStyle">
    <div class="chart-title">维保作业记录</div>
    <div class="maintenance-header">
      <div class="header-item">维保日期</div>
      <div class="header-item">维保周期</div>
      <div class="header-item">维保系统</div>
    </div>
    <div class="maintenance-table">
      <div
        class="maintenance-row"
        v-for="(record, index) in records"
        :key="index"
        @click="showMaintenanceDetail(record)"
        style="cursor: pointer"
      >
        <div class="maintenance-cell">{{ record.date }}</div>
        <div class="maintenance-cell">{{ record.cycle }}</div>
        <div class="maintenance-cell">{{ record.system }}</div>
      </div>
    </div>

    <!-- 维保详情弹窗 -->
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>维保详情</h3>
          <span class="close-btn" @click="closeModal">&times;</span>
        </div>
        <div class="modal-body">
          <!-- 加载状态 -->
          <div v-if="loading" style="text-align: center; color: #00d4ff; padding: 20px;">
            加载中...
          </div>
          
          <!-- 详情列表 -->
          <div v-else-if="detailList && detailList.length > 0" class="detail-list">
            <div class="detail-list-header">
              <div class="list-header-item">维保项名称</div>
              <div class="list-header-item">实验结果</div>
            </div>
            <div class="detail-list-body">
              <div
                class="detail-list-row"
                v-for="(item, index) in detailList"
                :key="index"
              >
                <div class="list-cell">{{ item.maintenanceItemDetailName || "-" }}</div>
                <div class="list-cell">{{ item.resultName || "-" }}</div>
              </div>
            </div>
          </div>
          
          <!-- 无数据提示 -->
          <div v-else style="text-align: center; color: #88c4ff; padding: 20px;">
            暂无详情数据
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dashboardAPI } from '@/api/dashboard'

export default {
  name: "MaintenanceRecords",
  props: {
    records: {
      type: Array,
      required: true,
      default: () => [],
    },
    containerStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showModal: false,
      selectedRecord: {},
      detailList: [],
      loading: false,
    }
  },
  methods: {
    async showMaintenanceDetail(record) {
      console.log('点击维保记录:', record)
      this.selectedRecord = { ...record }
      this.detailList = []
      this.showModal = true
      
      // 如果有fwbgld字段且不为空，调用详情接口
      // 注意：record.fwbgld是从API的fwbgId映射过来的
      console.log('fwbgld字段值:', record.fwbgld)
      if (record.fwbgld && record.fwbgld !== '') {
        this.loading = true
        try {
          console.log('开始请求维保详情接口，参数:', { fwbgld: record.fwbgld })
          const response = await dashboardAPI.getRecordInfo({ fwbgld: record.fwbgld })
          console.log('接口响应:', response)
          if (response && response.code === 1) {
            // 保存detailList数据
            this.detailList = response.data?.detailList || []
            console.log('获取到详情列表:', this.detailList)
            
          // 如果没有detailList，至少显示基本信息
          if (this.detailList.length === 0) {
            this.detailList = [{
              id: record.id || "-",
              maintenanceItemDetailName: record.maintenanceItemName || record.system || "-",
              bz: record.remark || "-",
              resultName: record.experimentResult || "-",
              updateTime: record.date || record.updateTime || "-"
            }]
          }
          } else {
            console.log('接口返回状态码不是1:', response)
            // 显示基本信息作为fallback
            this.detailList = [{
              id: record.id || "-",
              maintenanceItemName: record.maintenanceItemName || record.system || "-",
              remark: record.remark || "-",
              experimentResult: record.experimentResult || "-"
            }]
          }
        } catch (error) {
          console.error('获取维保详情失败:', error)
          // 显示基本信息作为fallback
          this.detailList = [{
            id: record.id || "-",
            maintenanceItemDetailName: record.maintenanceItemName || record.system || "-",
            bz: record.remark || "-",
            resultName: record.experimentResult || "-",
            updateTime: record.date || record.updateTime || "-"
          }]
        } finally {
          this.loading = false
        }
      } else {
        console.log('fwbgld字段为空或不存在，不请求接口')
        console.log('可用的记录字段:', Object.keys(record))
          // 显示基本信息
          this.detailList = [{
            id: record.id || "-",
            maintenanceItemDetailName: record.maintenanceItemName || record.system || "-",
            bz: record.remark || "-",
            resultName: record.experimentResult || "-",
            updateTime: record.date || record.updateTime || "-"
          }]
      }
    },
    closeModal() {
      this.showModal = false
      this.selectedRecord = {}
    },
  },
}
</script>

<style scoped lang="less">
// 维保作业样式
.maintenance-records {
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

// 图表标题样式 - 与页面保持一致
.chart-title {
  font-size: 16px;
  margin-bottom: 10px;
  color: #00d4ff;
  text-align: center;
  font-weight: bold;
}

.maintenance-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 2px solid rgba(0, 212, 255, 0.5);
  margin-bottom: 10px;
}

.maintenance-header .header-item {
  font-weight: bold;
  color: #00d4ff;
  flex: 1;
  text-align: center;
  font-size: 13px;
}

.maintenance-table {
  flex: 1;
  overflow-y: auto;
}

.maintenance-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background-color 0.3s;
}

.maintenance-row:hover {
  background-color: rgba(0, 212, 255, 0.1);
}

.maintenance-cell {
  color: #ffffff;
  font-size: 12px;
  flex: 1;
  text-align: center;
}

.maintenance-cell:first-child {
  color: #00d4ff;
}

// 弹窗样式
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: linear-gradient(135deg, #0a1929 0%, #1a2332 50%, #0e2a42 100%);
  border: 1px solid rgba(0, 212, 255, 0.5);
  border-radius: 10px;
  width: 90%;
  max-width: 600px;
  max-height: 90%;
  overflow-y: auto;
  box-shadow: 0 0 30px rgba(0, 212, 255, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid rgba(0, 212, 255, 0.3);
}

.modal-header h3 {
  color: #00d4ff;
  margin: 0;
  font-size: 18px;
}

.close-btn {
  color: #00d4ff;
  font-size: 24px;
  cursor: pointer;
  transition: color 0.3s;
}

.close-btn:hover {
  color: #ff3366;
}

.modal-body {
  padding: 20px;
}

.detail-list {
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 8px;
  overflow: hidden;
}

.detail-list-header {
  display: grid;
  grid-template-columns: 2fr 1.5fr;
  background: rgba(0, 212, 255, 0.1);
  border-bottom: 1px solid rgba(0, 212, 255, 0.3);
}

.list-header-item {
  padding: 12px 10px;
  color: #00d4ff;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  border-right: 1px solid rgba(0, 212, 255, 0.2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.list-header-item:last-child {
  border-right: none;
}

.detail-list-body {
  max-height: 400px;
  overflow-y: auto;
}

.detail-list-row {
  display: grid;
  grid-template-columns: 0.8fr 1.5fr 1.5fr 1.2fr 1.5fr;
  border-bottom: 1px solid rgba(0, 212, 255, 0.1);
}

.detail-list-row:last-child {
  border-bottom: none;
}

.detail-list-row:nth-child(even) {
  background: rgba(0, 212, 255, 0.05);
}

.list-cell {
  padding: 12px 15px;
  color: #ffffff;
  font-size: 12px;
  text-align: center;
  border-right: 1px solid rgba(0, 212, 255, 0.1);
  word-break: break-word;
}

.list-cell:last-child {
  border-right: none;
}

/* 自定义滚动条 */
.detail-list-body::-webkit-scrollbar {
  width: 6px;
}

.detail-list-body::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
}

.detail-list-body::-webkit-scrollbar-thumb {
  background: rgba(0, 212, 255, 0.5);
  border-radius: 3px;
}

.detail-list-body::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 212, 255, 0.8);
}

// 滚动条样式
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 212, 255, 0.5);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 212, 255, 0.8);
}

.detail-list {
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 6px;
  overflow: hidden;
}
.detail-list-header {
  display: flex;
  background: rgba(0, 212, 255, 0.15);
  font-weight: bold;
  color: #00d4ff;
}
.list-header-item {
  flex: 1;
  padding: 8px 12px;
  text-align: center;
  border-right: 1px solid rgba(0, 212, 255, 0.2);
}
.list-header-item:last-child {
  border-right: none;
}
.detail-list-body {
  max-height: 300px;
  overflow-y: auto;
}
.detail-list-row {
  display: flex;
  border-top: 1px solid rgba(0, 212, 255, 0.2);
}
.detail-list-row:nth-child(even) {
  background: rgba(0, 212, 255, 0.05);
}
.list-cell {
  flex: 1;
  padding: 8px 12px;
  text-align: center;
  color: #e0f7ff;
  border-right: 1px solid rgba(0, 212, 255, 0.2);
}
.list-cell:last-child {
  border-right: none;
}
</style>
